import React from 'react';
import _ from 'lodash';
import { Box, Card, CardContent, Stack, Button, Typography } from '@mui/material';
import { SmallFormTextField } from '../../../components/small-fields/SmallFormTextField';
import {
  validateValues,
  validateRequiredFields
} from '../../../services/functions';

export const CreateProductsForm = ({ handleSubmit, loading }) => {
  const [participantGrossValue, setParticipantGrossValue] = React.useState('');
  const [guardianGrossValue, setGuardianGrossValue] = React.useState('');
  const [errors, setErrors] = React.useState([]);
  const [requiredFields, setRequiredFields] = React.useState(['participantGrossValue', 'guardianGrossValue']);

  const validateValue = (value, type, maxLength, name, required) => {
    setErrors(validateValues(errors, value, type, maxLength, name));
    if (required) {
      setRequiredFields(
        validateRequiredFields(requiredFields, value, name, required)
      );
    }
  };
  console.log(errors, requiredFields);

  return (
    <Card >
      <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="body1" textAlign="center">
            Nie udało się utworzyć pozycji zamówienia.
            Prawdopodobnie użytkownik wybrał okres, do którego nie był przydzielony żaden przedział płatności.
            Czy chcesz je utworzyć teraz?
        </Typography>
        <Box height={40} />
        <Stack direction="column">
          <Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} pb={1}>
              <Typography variant="subtitle2" flex="1 1 50%">Kwota za uczestnika (zł)</Typography>
              <SmallFormTextField
                sx={{ flex: '1 1 50%' }}
                placeholder="kwota za uczestnika"
                value={participantGrossValue}
                onChange={e => {
                  validateValue(
                    e.target.value,
                    'float',
                    null,
                    'participantGrossValue',
                    true
                  );
                  setParticipantGrossValue(e.target.value);
                }}
                error={errors.includes('participantGrossValue') || requiredFields.includes('participantGrossValue') ? true : false}
                helperText={
                  errors.includes('participantGrossValue')
                    ? 'Proszę wprowadzić odpowiednią liczbę'
                    : requiredFields.includes('participantGrossValue')
                      ? 'To pole jest wymagane'
                      : ''
                }
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} pb={1}>
              <Typography variant="subtitle2" flex="1 1 50%">Kwota za opiekuna (zł)</Typography>
              <SmallFormTextField
                sx={{ flex: '1 1 50%' }}
                placeholder="kwota za opiekuna"
                value={guardianGrossValue}
                onChange={e => {
                  validateValue(
                    e.target.value,
                    'float',
                    null,
                    'guardianGrossValue',
                    true
                  );
                  setGuardianGrossValue(e.target.value);
                }}
                error={errors.includes('guardianGrossValue') || requiredFields.includes('guardianGrossValue') ? true : false}
                helperText={
                  errors.includes('guardianGrossValue')
                    ? 'Proszę wprowadzić odpowiednią liczbę'
                    : requiredFields.includes('guardianGrossValue')
                      ? 'To pole jest wymagane'
                      : ''
                }
              />
            </Stack>
          </Stack>
          <Stack flexDirection="row" justifyContent="space-around">
            <Button sx={{ flexGrow: 0.4 }} variant="contained" disabled={loading || !_.isEmpty(errors) || !_.isEmpty(requiredFields)} onClick={() => handleSubmit(participantGrossValue, guardianGrossValue)}>Utwórz</Button>
          </Stack>
        </Stack>

      </CardContent>
    </Card>
  );
};
